// Shared styling helpers for the public game page + editor previews.
import { fontStyle } from "./fonts";

export const BUTTON_RADIUS = {
  pill: "9999px",
  rounded: "0.75rem",
  square: "0.375rem",
};

export const DEFAULT_CONFETTI = [
  "#d4af37",
  "#f5e4bf",
  "#a98027",
  "#8B5CF6",
  "#ec4899",
];

// Main accent color (custom button color → theme color → default violet).
export function accentColor(game) {
  return game?.button_bg_color || game?.theme_color || "#8B5CF6";
}

// Accent as CSS background: 2-color gradient when a 2nd color is set, else solid.
export function accentBackground(game) {
  const c1 = accentColor(game);
  return game?.button_bg_color_2
    ? `linear-gradient(135deg, ${c1} 0%, ${game.button_bg_color_2} 100%)`
    : c1;
}

// Inline style for the main flow buttons (fonts + custom colors + shape).
export function buttonStyle(game) {
  const s = { ...fontStyle(game?.fonts, "buttons") };
  if (game?.button_bg_color_2) s.background = accentBackground(game);
  else if (game?.button_bg_color) s.backgroundColor = game.button_bg_color;
  if (game?.button_text_color) s.color = game.button_text_color;
  if (game?.button_radius && BUTTON_RADIUS[game.button_radius])
    s.borderRadius = BUTTON_RADIUS[game.button_radius];
  return s;
}

// Dark legibility overlay over the background image. 0–100, default 55.
export function overlayGradient(game) {
  const raw = game?.bg_overlay_opacity;
  const v = raw == null ? 55 : Math.min(100, Math.max(0, raw));
  const strong = (v / 100).toFixed(2);
  const soft = ((v * 0.18) / 100).toFixed(3);
  return `linear-gradient(to bottom, rgba(10,12,24,${strong}) 0%, rgba(10,12,24,${soft}) 25%, rgba(10,12,24,${soft}) 70%, rgba(10,12,24,${strong}) 100%)`;
}

export function confettiColors(game) {
  return game?.confetti_colors?.length
    ? game.confetti_colors
    : DEFAULT_CONFETTI;
}
